export default "__VITE_ASSET__xpzrclStW7T9JPQ$qICj$w__";